<template lang="pug">
include /mixins
trip-state(
  :trip_label='trip_label'
)
  template(#state='{ hasDebt, isOk, isPerfect, debt, oldDebt, actual, message }')
    div
      +b.trip-monthly-case(v-if='trip.trip_potential_participant')
        +e.head.tt-space_mb--4
          +e.title.SPAN {{ _('Общая сумма закупки') }} &nbsp;
            span(v-html='getSplittedHtml(trip.trip_potential_participant.props.purchase_amount, currency)')
        +e.progress
          chart(
            :chart-data='chartData'
            :options='chartOptions'
          )
          div(id="custom-tooltip-circle" class="custom-tooltip-label" style="opacity: 0")
        +e.sum-info.tt-space_mb--6
          +e.sum-info-element
            +b.sum.ds-caption--size_3md.--semibold.P(
              v-html='getSplittedHtml(trip.trip_potential_participant.props.total_actual_sale, currency)'
            )
            +b.ds-caption--size_xs.--medium.P {{ _('фактически куплено') }}
          +e.sum-info-element
            +b.sum.ds-caption--size_3md.--semibold.P(
              v-if='remainder > 0'
              v-html='getSplittedHtml(remainder, currency)'
            )
            +b.sum.ds-caption--size_3md.--semibold.P(
              v-else
              v-html='getSplittedHtml(0, currency)'
            )
            +b.ds-caption--size_xs.--medium.P {{ _('осталось') }}
        +b.trip-terms
          template(v-for='(item, index) in trip.conditions')
            +b.trip-term
              +e.name-wrap
                +e.color(
                  :style="{ backgroundColor: $options.COLORS[index % $options.COLORS.length] }"
                )
                +e.name.P {{ item.props.condition_name_for_sso }}
              +e.values.P {{ getPercent(item.props.actual_sale, item.props.purchase_value) }}%/100%

              +b.toggler
                +e.input.INPUT(
                  type='checkbox',
                  :id='`condition-info-${item.id}`',
                )
                +e.label--blog.LABEL(
                  :for='`condition-info-${item.id}`',
                )
                  p.trip-term__details(

                  ) {{ _('Детальнее') }}
                +e.content--top.js-modal-delivery
                  .vm--overlay.js-modal-close(
                    :data-name='`condition-info-${item.id}`',
                  )
                  .vm--modal.condition-modal
                    +b.condition-chart-modal
                      +b.close-popup.js-modal-close.A(
                        :data-name='`condition-info-${item.id}`',
                      ).mdi.mdi-close
                      +e.title.H3 {{ item.props.condition_name_for_sso }}
                      +e.content
                        +e.chart
                          chart(
                            :chart-data='generateChartData(item, index)'
                            :options='miniChartOptions'
                          )
                          +e.value.P {{ getPercent(item.props.actual_sale, item.props.purchase_value) }}%/100%
                          div(id="mini-custom-tooltip-circle" class="custom-tooltip-label" style="opacity: 0")
                        +e.data
                          +e.total.P {{ _('Общая сумма') }}: &nbsp;
                            span(
                              style='white-space: nowrap;'
                              v-html='getSplittedHtml(item.props.purchase_value, currency)'
                            )
                          +b.trip-term-value
                            +e.text.P {{ _('фактически куплено') }}
                            +e.sum.P(
                              v-html='getSplittedHtml(item.props.actual_sale, currency)'
                            )
                          +b.trip-term-value(
                            v-if='(item.props.purchase_value - item.props.actual_sale) > 0'
                          )
                            +e.text.P {{ _('осталось') }}
                            +e.sum.P(
                              v-html='getSplittedHtml(item.props.purchase_value - item.props.actual_sale, currency)'
                            )
                          +b.trip-term-value(
                            v-else
                          )
                            +e.text.P {{ _('осталось') }}
                            +e.sum.P(
                              v-html='getSplittedHtml(0, currency)'
                            )
                      +e.button
                        +b.tt-button.A(
                          :href="item.props.url"
                          target="_blank"
                        )
                          +e.title {{ _('Выбрать товары для этой закупки') }}
            +b.trip-condition-done(v-if='Number(item.props.purchase_value) <= Number(item.props.actual_sale)')
              +e.title {{ _('Условие выполнено') }}

</template>

<script>

import {
  mapState, mapActions,
} from 'vuex'

import { format } from 'date-fns'

import { COLORS } from '@app/Trips/const'

import {
  COUNTRY_CODE_COOKIE_NAME,
  DEFAULT_DATE_FORMAT,
} from '@app/consts'

import {
  fakeModalCloser,
} from '@utils/ui-scripts'

import ConditionMessage from '@app/Trips/ConditionMessage.vue'

const chart = () => import('@app/Trips/Doughnut.vue')

const CURRENT_MONTH_STATUS = 'current'

export default {
  props: {
    trip_label: {
      type: String,
      required: true,
    },
  },
  components: {
    chart, ConditionMessage,
  },
  COLORS,
  data() {
    return {
      currency: window.currency,
      DEFAULT_DATE_FORMAT,
      miniChartOptions: {
        rotation: -Math.PI / 2,
        circumference: Math.PI * 2,
        cutoutPercentage: 70,
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        animation: {
          animateRotate: true,
          animateScale: true,
        },
        tooltips: {
          enabled: false,
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      },
    };
  },
  computed: {
    ...mapState('trip', ['trip']),
    currentMonthDistribution() {
      if (this.trip && this.trip.trip_potential_participant && this.trip.trip_potential_participant.props) {
        return this.trip.trip_potential_participant.props.monthly_distribution.find(e => e.status === CURRENT_MONTH_STATUS)
      }
      return null
    },
    remainder() {
      if (!this.trip || !this.trip.trip_potential_participant) return 0;
      return Math.max(
         this.trip.trip_potential_participant.props.purchase_amount - this.trip.trip_potential_participant.props.total_actual_sale,
      0)
    },
    lastDay() {
      return this.trip.trip_potential_participant.props.planned_date_of_redemption.split(' ')[0]
      // return format(this.trip.trip_potential_participant.props.planned_date_of_redemption, DEFAULT_DATE_FORMAT)
    },
    totalPurchase() {
      return this.trip.conditions.reduce((acc, item) => acc + Number(item.props.actual_sale || 0), 0)
    },
    chartData() {
      if (this.trip.conditions && !this.trip.conditions.length) return null;
      const values = this.trip.conditions.map(c => Number(c.props.actual_sale) || 0)
      const data = [...values]
      if (0 < this.remainder) {
        data.push(this.remainder)
      }
      const bgColors = [...COLORS.slice(0, values.length), '#fff']

      return {
        labels: [...this.trip.conditions.map(c => c.props.condition_name_for_sso), this._('Осталось')],
        datasets: [
          {
            data,
            backgroundColor: bgColors,
            borderWidth: 0,
          },
        ],
      }
    },
    chartOptions() {
      return {
        cutoutPercentage: 70,
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        animation: {
          animateRotate: true,
          animateScale: true,
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          enabled: false,
          custom(tooltipModel) {
            const tooltipEl = document.getElementById('custom-tooltip-circle');
            if (!tooltipEl) return;

            // Ховати при 0 opacity
            if (0 === tooltipModel.opacity) {
              tooltipEl.style.opacity = 0;
              return;
            }

            // Очистити тултіп
            tooltipEl.innerHTML = '';

            // Формування тултіпу
            if (tooltipModel.body && tooltipModel.body.length) {
              const table = document.createElement('table');
              table.style.margin = '0';

              tooltipModel.body.forEach((bodyItem, i) => {
                const color = tooltipModel.labelColors[i];
                const value = bodyItem.lines[0];

                const tr = document.createElement('tr');

                // Квадратик
                const tdColor = document.createElement('td');
                tdColor.style.width = '12px';
                tdColor.style.paddingRight = '6px';
                tdColor.innerHTML = `<span style="
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  background-color: ${color.backgroundColor};
                  border: 1px solid ${color.borderColor};
                  border-radius: 50%;
                  margin-right: 4px;
                  vertical-align: middle;
                "></span>`;

                // Текст
                const tdText = document.createElement('td');
                tdText.style.color = '#fff';
                tdText.style.fontSize = '12px';
                tdText.innerText = value;

                tr.appendChild(tdColor);
                tr.appendChild(tdText);
                table.appendChild(tr);
              });

              tooltipEl.appendChild(table);
            }

            const canvasRect = this._chart.canvas.getBoundingClientRect();
            const tooltipWidth = tooltipEl.offsetWidth;
            const tooltipHeight = tooltipEl.offsetHeight;

            let left = canvasRect.left + window.pageXOffset + tooltipModel.caretX;
            let top = canvasRect.top + window.pageYOffset + tooltipModel.caretY - tooltipHeight - 10;

            const maxLeft = window.innerWidth - tooltipWidth - 10;
            if (left > maxLeft) left = maxLeft;

            if (10 > left) left = 10;

            if (10 > top) {
              top = canvasRect.top + window.pageYOffset + tooltipModel.caretY + 10;
            }
            tooltipEl.style.opacity = 1;
            tooltipEl.style.position = 'absolute';
            tooltipEl.style.pointerEvents = 'none';
            tooltipEl.style.left = `${left}px`;
            tooltipEl.style.top = `${top}px`;
            tooltipEl.style.height = 'auto';
          },
        },
        plugins: {
          datalabels: {
            color: '#000', // 👈 Білий колір
            font: {
              weight: 'bold',
              size: 14,
            },
          },
        },
      }
    },
  },
  mounted() {
    setTimeout(() => {
      fakeModalCloser()
    }, 1000);
  //   this.getTrip(this.trip_label);
  },
  methods: {
    format,
    ...mapActions('trip', ['getTrip']),
    getPercent(value, from) {
      return Math.round((Number(value) / Number(from)) * 100) || 0;
    },
    addCondition() {
      this.$emit('add-condition', this.condition);
      this.condition = {
        trip: this.trip,
        name: '',
        description: '',
      };
    },
    generateChartData(item, idx) {
      const used = item.props.actual_sale
      const remaining = Math.max(item.props.actual_sale - item.props.actual_sale, 0)
      return {
        labels: ['used', 'remaining'],
        datasets: [{
          data: [used, remaining],
          backgroundColor: [COLORS[idx % COLORS.length], '#E9F0F6'],
          borderWidth: 0,
        }],
      }
    },
  },
}

</script>
